export default __webpack_public_path__ + "static/sample-photo-link-badge-1a4c1c8f2d242abfa4be3ceb7c4f8e57.png";